import { sample } from 'effector';
import { selectionRowChanged } from '../../table/table.model';
import { statuses } from '../init';

export const selectTableRow = () => {
  sample({
    clock: statuses.openedOnlyTable,
    fn: () => [],
    target: selectionRowChanged,
  });

  sample({
    clock: statuses.openedTableAndExistedTicket,
    fn: (openedId) => [openedId!],
    target: selectionRowChanged,
  });
};
